<template>
  <div></div>
</template>

<script>
export default {
  name: 'Idle',

  data() {
    return {
      timer: null,
    };
  },

  props: {
    // Time in minutes of inactivity before idle
    time: {
      type: Number,
      default: 10,
    },
    // Function called when application goes idle
    // By default, we load index.html
    onIdle: {
      type: Function,
      default: () => {
        window.location.replace('index.html');
      },
    },
  },

  mounted() {
    const events = ['mousedown', 'touchstart'];
    events.forEach((event) => {
      window.addEventListener(event, this.restartTimer);
    });
  },

  methods: {
    restartTimer() {
      window.clearTimeout(this.timer);
      this.timer = window.setTimeout(this.onIdle, this.time * 60 * 1000);
    },
  },
};
</script>
